<template>
  <div class="login flex">
    <orderList
      :oList="oList"
      :toggleLoginFn.sync="toggleLoginFn"
      v-if="isLogin"
    ></orderList>
    <div v-else>
      <div>已经制作过照片</div>
      <div>
        <a-button @click="loginBtn" class="loginBtn" type="link"
          >点击登录</a-button
        >找回之前的订单
        <a-modal
          :footer="null"
          :maskClosable="false"
          centered
          :destroyOnClose="true"
          :visible="loginModal"
          v-if="loginModal"
          @cancel="cancelLoginModal"
        >
          <div class="login-modal">
            <p class="title">第三方登录</p>
            <div v-if="isWxLogin" id="qr">
              <img class="qr-code-img" :src="qrCodeUrl" alt />
              <div class="qr-code-img" id="login_container"></div>
              <div class="qr-code-tips">扫描二维码登录</div>
            </div>
            <div class="login-way">
              <a-radio-group @change="changeLoginWay" v-model="loginWayidx">
                <a-radio-button
                  :class="[
                    idx == loginWayidx
                      ? 'login-way-item active'
                      : 'login-way-item',
                  ]"
                  v-for="(item, idx) in loginWayArr"
                  :value="+idx"
                  :key="idx"
                >
                  <div class="item-img">
                    <img :src="item.img" alt />
                  </div>
                  <div>{{ item.name }}</div>
                </a-radio-button>
              </a-radio-group>
            </div>
            <p class="tips">
              <!-- 支付订单后在当前登录方式 请用支付订单的支付方式登录 -->
            </p>
          </div>
        </a-modal>
      </div>
    </div>
  </div>
</template>

<script>
import orderList from "@/components/orderList.vue";
import { setCookie, getCookie, delCookie } from "../utils/cookie";
import {
  wechatLogin,
  wxLogin,
  aliLogin,
  wxLoginHeart,
  getOrders,
} from "@/utils/api";
export default {
  name: "login",
  props: {
    isLogin: { type: Boolean, default: false },
    loginModal: Boolean,
    loginBtnFn: Function,
    cancel: Function,
    // oList: Array,
    toggleLoginFn: Function,
    type: String,
  },
  components: {
    orderList,
  },
  data() {
    return {
      oList: [],
      qrCodeUrl: "",
      loginWayArr: [
        { name: "微信登录", img: require("../assets/wechat.png") },
        { name: "支付宝登录", img: require("../assets/Alipay.png") },
      ],
      isWxLogin: false,
      loginWayidx: null,
      // orderList: []
    };
  },
  watch: {
    loginModal: function (val) {
      if (val === false) {
        this.getWxTokentimer instanceof Function &&
          clearTimeout(this.getWxTokentimer);
        this.wxqrEffectiveTimer instanceof Function &&
          clearTimeout(this.wxqrEffectiveTimer);
        this.wxqrEffective = false;
      }
    },
  },
  mounted() {
    // let token = this.$route.query.token;
    // if (token) {
    //   setCookie("lq-handlephoto-token", token, 1);
    // }
    this.getOrdersList();
  },
  methods: {
    cancelLoginModal() {
      this.isWxLogin = false;
      this.loginWayidx = null;
      this.qrCodeUrl = "";
      this.cancel();
    },
    loginBtn() {
      this.loginBtnFn();
    },
    changeLoginWay(e) {
      this.loginWayidx = e.target.value;
      // setCookie("loginWayName", this.loginWayArr[this.loginWayidx].name, 1);
      // console.log(e.target.value);
      if (this.loginWayidx == 0) {
        this.isWxLogin = true;
        wechatLogin({ url: window.location.href }).then(({ qr_code }) => {
          // console.log(res, "res");
          const { app_id: appid, ...rest } = qr_code;
          var obj = new WxLogin({
            id: "login_container",
            appid,
            ...rest,
          });
        });
        // wxLogin({ url: window.location.href }).then((res) => {
        //   this.qrCodeUrl = res.url;
        //   this.wxqrEffective = true;
        //   this.wxqrEffectiveTimer = setTimeout((_) => {
        //     this.wxqrEffective = false;
        //   }, res.ex * 1000);
        //   this.getWxTokenHeart(res.key);
        // });
      } else {
        this.isWxLogin = false;
        aliLogin({ url: window.location.href }).then((res) => {
          // console.log("res::login", res);
          let url = res.qr_code_url;
          window.location.href = url;
        });
      }
    },
    // getWxTokenHeart(key) {
    //   wxLoginHeart(key).then((res) => {
    //     this.getWxTokentimer = setTimeout((_) => {
    //       res.token ? this.handleToken(res.token) : this.tryGetToken(key);
    //     }, 2000);
    //   });
    // },
    // handleToken(token) {
    //   setCookie("lq-handlephoto-token", token, 1);
    //   clearTimeout(this.wxqrEffectiveTimer);
    //   clearTimeout(this.getWxTokentimer);
    //   this.toggleLoginFn(true);
    //   this.getOrdersList();
    //   this.cancelLoginModal();
    // },
    tryGetToken(key) {
      this.wxqrEffective ? this.getWxTokenHeart(key) : this.lostWxqrEffective();
    },
    lostWxqrEffective() {
      clearTimeout(this.wxqrEffectiveTimer);
      clearTimeout(this.getWxTokentimer);
      this.wxqrEffective = false;
      if (this.loginModal) {
        this.$error({
          title: "二维码失效",
          content: "请重新打开二维码登录！",
        });
      }
      this.cancelLoginModal();
    },
    getOrdersList() {
      if (getCookie("lq-handlephoto-token")) {
        getOrders({
          token: "Bearer " + getCookie("lq-handlephoto-token"),
          type: this.type,
        }).then((res) => {
          this.oList = res.map((item) => {
            item.colours = JSON.parse(item.colours);
            return item;
          });
        });
      }
    },
  },
};
</script>
<style scoped>
.login {
  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 13px;
  color: #adadae;
}

.loginBtn {
  padding: 0;
}
.login-modal {
  text-align: center !important;
}
.login-modal .title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303133;
  margin-bottom: 44px;
}
.login-way .active {
  color: #438bf9;
}
.login-way-item {
  display: inline-block;
  margin: 0 20px;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  background: rgba(245, 247, 250, 1);
  border-radius: 8px;
}
.item-img::before {
  content: "";
  width: 0;
  height: 100%;
  display: inline-block;
  vertical-align: middle;
}
.active .item-img {
  border: 2px solid #438bf9;
}
.login-way-item .item-img img {
  width: 32px;
}
.tips {
  font-size: 12px;
  color: #adadae;
  margin: 33px 0;
}
.qr-code-img {
  margin-bottom: 5px;
}
.qr-code-tips {
  margin-bottom: 34px;
}
</style>
